import styled from 'styled-components';

export const StyledNotFoundPage = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
`;
